import Decimal from 'decimal.js';

const refreshIconAnimation = {
  rotate: [0, 0, 0, 180, 180, 360, 360, 360, 360, 360, 360],
  scale: [1, 1.3, 1.3, 1, 1, 1, 1, 1.3, 1.3, 1, 1],
  timings: [0, 0.3, 0.1, 0.3, 0.3, 0.3, 0.3, 0.3, 0.3, 0.2, 0.2],
};

const resourceImgAnimation = {
  opacity: [1, 1, 1, 0],
  left: [0, '100%', '100%', '100%'],
  timings: [0, 0.3, 0.1, 0.3],
};

const materialImgAnimation = {
  filter: [
    'drop-shadow(0px 0px 0px rgba(0, 0, 0, 0))',
    'drop-shadow(0px 0px 0px rgba(0, 0, 0, 0))',
    'drop-shadow(0px 0px 0px rgba(0, 0, 0, 0))',
    'drop-shadow(0px 0px 5px rgba(130, 224, 36, 0.5))',
    'none',
  ],
  opacity: [0, 1, 1, 1, 0],
  scale: [1, 1, 1, 3, 3],
  x: ['-50%', '-50%', '-50%', '-50%', '-50%'],
  left: [0, 0, '100%', '100%', '100%'],
  timings: [0, 0.3, 0, 3, 0, 2, 0, 2],
};

const generageTimes = (duration: number, timings: number[]): number[] => {
  const durationDecimal = new Decimal(duration);
  const cof = new Decimal(0.1).div(durationDecimal).toNumber();

  let lastResult = 0;

  return timings.map((timing, index, arr) => {
    if (index === 0) {
      return 0;
    }

    if (index === arr.length - 1) {
      lastResult = 0;

      return 1;
    }

    const decimalTimign = new Decimal(timing);

    const result = decimalTimign
      .div(new Decimal(0.1))
      .mul(cof)
      .plus(new Decimal(lastResult))
      .toNumber();
    lastResult = result;

    return result;
  });
};

export {
  generageTimes,
  materialImgAnimation,
  refreshIconAnimation,
  resourceImgAnimation,
};
